import { gql } from '@apollo/client';

export const GET_LEARNER_DOCUMENTS = gql`
  query GetLearnerDocuments {
    documentLibrary(order_by: { updatedAt: Desc }) {
      id
      name
      url
      size
      createdAt
      updatedAt
      isVectorized
      documentLibraryTeams {
        team {
          id
          name
        }
      }
    }
  }
`;
